module.exports = __webpack_public_path__ + "img/HumanMale_Knight.fb8a963e.png";